import React from "react";
import ReactDOM from "react-dom";
import PortalReactDOM from "react-dom";

const Model = ({ hide, link }) => {
    return PortalReactDOM.createPortal(
        <div className="custom-modal-overlay">
            <div
                className="custom-modal-wrapper"
                aria-modal
                aria-hidden
                tabIndex={-1}
                role="dialog"
            >
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <button
                            type="button"
                            className="modal-close-button"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={hide}
                            style={{
                                width: "fit-content",
                                padding: 0,
                                marginTop: "5px",
                                marginRight: "5px",
                            }}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewPort="0 0 12 12"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ backgroundColor: "transparent" }}
                            >
                                <line
                                    x1="1"
                                    y1="19"
                                    x2="19"
                                    y2="1"
                                    stroke="black"
                                    stroke-width="2"
                                />
                                <line
                                    x1="1"
                                    y1="1"
                                    x2="19"
                                    y2="19"
                                    stroke="black"
                                    stroke-width="2"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="custom-model-content">
                        {link &&
                            <iframe style={{ width: "100%", opacity: "100%", backgroundColor: "white" }} src={link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" allowfullscreen ></iframe>}
                        {!link && <h3 style={{ width: "100%", opacity: "100%", backgroundColor: "white", textAlign: "center" }}>No video available</h3>}
                    </div>
                </div>
            </div>

        </div>,
        document.body
    );
};

export default Model;